<script setup lang="ts">
import { watch, ref, nextTick } from 'vue';
import { useRoute } from 'vue-router';

import Card from 'primevue/card';

import CalculationItemsPreview from '../components/CalculationItemsPreview.vue';
import CalculationItems from '../components/CalculationItems.vue';

const wrapper = ref<HTMLElement | null>(null);

const route = useRoute();
watch(
  () => route.params,
  (newVal, oldVal) => {
    nextTick(() => {
      if (wrapper.value) {
        const target = wrapper.value.querySelector('.p-step.p-step-active');
        setTimeout(() => {
          target?.scrollIntoView();
        }, 200);
      }
    });

    if (newVal.groupId === oldVal?.groupId) return;

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 50);
  },
  {
    deep: true,
  }
);

watch(
  wrapper,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        const target = newVal.querySelector('.p-step.p-step-active');
        target?.scrollIntoView();
      });
    }
  },
  { immediate: true }
);
</script>

<template>
  <div v-auto-animate class="grid grid-cols-[1fr_auto] gap-6">
    <Card class="h-max max-h-[70vh] overflow-y-auto border border-gray-200 !shadow-none">
      <template #content>
        <section ref="wrapper" v-auto-animate>
          <CalculationItems />
        </section>
      </template>
    </Card>

    <CalculationItemsPreview class="max-h-[70vh] min-w-[480px] overflow-y-auto" />
  </div>
</template>
